import { TenantGroupsSection } from '../TenantGroupsSection';
import { TenantLabelsSection } from '../TenantLabelsSection';
import './TenantLabelsAndGroupsTab.css';

export function TenantLabelsAndGroupsTab() {
  return (
    <div className="tenant-labels-groups">
      <TenantGroupsSection />
      <TenantLabelsSection />
    </div>
  );
}
